import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { css } from 'react-emotion';

const propTypes = {
  type: PropTypes.oneOf([ undefined, 'button', 'link', 'submit' ]),
  label: PropTypes.string,
  children: PropTypes.any,
  className: PropTypes.string,
  to: PropTypes.string
};

const Button = ({ type = 'button', label, children, className, disabled, onClick, ...rest }) => {
  const Tag = type === 'link' ? Link : 'button';
  const btnClassName = `${type === 'link' ? linkClass : ''} ${className || ''}`;
  const handleClick = disabled ? (e) => e.preventDefault() : onClick;
  const Inner = type === 'link' ? 'div' : React.Fragment;

  return (
    <Tag className={btnClassName} {...rest} onClick={handleClick} disabled={disabled}><Inner>{label || children}</Inner></Tag>
  );
}

Button.propTypes = propTypes;
export default Button;

const linkClass = css`
  display: inline-block;
  /* :hover,
  :focus,
  :active {
    color: #fff;
  } */
  > * {
    display: flex;
    vertical-align: middle;
    height: 100%;
    align-content: center;
    align-items: center;
  }
`;


// WEBPACK FOOTER //
// ./src/components/ui/Button.jsx